

const state = {
 
        "200":{
            "type":"light-green darken-3",
            "view":null
        },    
        "404":{
            "type":"grey darken-4",
            "view":"Error404"
        },
        "422":{
            "type":"grey darken-4",
            "view":null
        },
        "500":{
            "type":"grey darken-4",
            "view":"Error500"
        },

    
};

export default {
  namespaced: true,
  state,
 
};